import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import { getData } from 'utils/dynamicData';
import { joinClasses, sortObjectByOrder, triggerAnim } from 'utils/utils';
import { clamp } from 'utils/math';

import Play from 'components/icons/playButton';
import Pause from 'components/icons/pauseButton';

import s from 'components/promoTouts/promoTouts.sss';

export default class PromoTouts extends Component {
	constructor(props) {
		super(props);

		this.slides = [];
		this.intervalDuration = 5000;
		this.state = {
			slideIndex: 0,
			isPlaying: true,
		};
		this.timerRef = null;

		this.next = this.next.bind(this);
		this.togglePlay = this.togglePlay.bind(this);
		this.onToutClick = this.onToutClick.bind(this);
		this.renderGroup = this.renderGroup.bind(this);
		this.renderTout = this.renderTout.bind(this);

		if (typeof window !== 'undefined') {
			this.loadData();
		}
	}

	async loadData() {
		try {
			const data = await getData('landing');
			let slides = sortObjectByOrder(data?.promoTouts?.list);
			// temporarily allow legacy data format - remove later
			slides = slides?.map(item => ({ ...item, ...item?.content?.[0] }));
			this.updateSlides(slides);
		} catch (err) {
			console.error(err);
		}
	}

	componentWillUnmount() {
		clearTimeout(this.timer);
	}

	chunk(arr, size) {
		if (!Array.isArray(arr)) return [];
		const result = [];
		for (let i = 0; i < arr.length; i += size) {
			result.push(arr.slice(i, i + size));
		}
		return result;
	}

	updateSlides(items) {
		this.slides = this.chunk(items?.filter(e => e?.image), 2);
		this.goToSlide(0);
	}

	shouldAutoplay() {
		return this.slides.length > 1;
	}

	autoplay() {
		clearTimeout(this.timer);

		if (!this.shouldAutoplay() || !this.state.isPlaying) {
			return;
		}

		this.timer = setTimeout(this.next, this.intervalDuration);
		triggerAnim(this.base, s.playing);
	}

	next() {
		this.goToRelativeSlide(1);
	}

	goToSlide(index) {
		clearTimeout(this.timer);
		this.setState({ slideIndex: clamp(index, 0, this.slides.length - 1) });
		this.autoplay();
	}

	goToRelativeSlide(step) {
		this.goToSlide(
			(this.state.slideIndex + step) % this.slides.length
		);
	}

	togglePlay() {
		clearTimeout(this.timer);
		const isPlaying = !this.state.isPlaying;
		this.setState({ isPlaying });
		this.autoplay();

		Store.emit(actions.PROMO_VIDEO_SLIDE_PLAY_TOGGLE, {
			state: isPlaying,
			count: this.slides.length,
		});
	}

	onToutClick(e) {
		const title = e.currentTarget.querySelector('img')?.alt || '';
		Store.emit(actions.PROMO_TOUT_CLICK, { title });
	}

	renderTout(tout) {
		const image = <img class={s.poster} src={tout.image} alt={tout.title} width="800" height="500" />;
		if (!tout.link) {
			return <div class={s.posterWrapper} key={tout.id}>{image}</div>;
		}
		return (
			<a
				class={s.posterWrapper}
				href={tout.link}
				target="_blank"
				onClick={this.onToutClick}
				key={tout.id}
			>
				{image}
			</a>
		);
	}

	renderGroup(group, index) {
		const key = group.map(e => e.id).join('|');
		return (
			<div class={joinClasses(s.slidesGroup, this.state.slideIndex === index && s.active)} key={key}>
				{group.map(this.renderTout)}
			</div>
		);
	}

	render() {
		const { isPlaying } = this.state;

		if (!Array.isArray(this.slides) || !this.slides.length) {
			return null;
		}

		return (
			<div class={joinClasses(s.wrapper, isPlaying && s.playing)} style={`--duration: ${this.intervalDuration}ms`}>
				<div class={s.slidesWrapper}>
					{this.slides.map(this.renderGroup)}
				</div>
				<div class={joinClasses(s.controls, !this.shouldAutoplay() && s.hidden)}>
					<button class={s.play} onClick={this.togglePlay} aria-label={`Turn ${isPlaying ? 'off' : 'on'} autoplay of promotional touts`}>
						{isPlaying ? <Pause height="14" /> : <Play height="14" />}
					</button>
				</div>
			</div>
		);
	}
}
